<template>
  <div class="benefits-area pt-100">
    <div class="container mw-1356">
      <div class="row">
        <div class="col-xl-6" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="100">
          <div class="benefits-img">
            <img :src="c.image_url || benefitsImg" alt="benefits" />
            <div class="review mb-minus-53">
              <div class="review-in">
                <span>EXPERIENCE OF</span>
                <div class="stat-figure stat-figure-light">{{ c.experience_years }} Yrs</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-6">
          <div class="benefits-content">
            <span class="top-title">{{ c.top_title }}</span>
            <h2 class="text-white">{{ c.title }}</h2>
            <div class="row">
              <div v-for="(benefit, index) in c.items" :key="index" class="col-lg-6"
                data-aos="fade-up" data-aos-duration="1000" :data-aos-delay="200 + (index % 2) * 100">
                <div class="d-flex benefits-single-item">
                  <div class="flex-shrink-0"><i :class="benefit.icon"></i></div>
                  <div class="flex-grow-1 ms-3">
                    <h3>{{ benefit.title }}</h3>
                    <p>{{ benefit.description }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useContent } from "@/composables/useContent";

export default defineComponent({
  name: "OnlyBenefits",
  setup() {
    const { content: c } = useContent("benefits", {
      top_title: "BENEFITS", title: "Only benefits", experience_years: 10,
      image_url: "",
      items: [
        { icon: "flaticon-antena", title: "Top Rated Channels", description: "Enjoy Top rated TV channels with the best streaming experience." },
        { icon: "flaticon-wifi-router", title: "Fast Connected", description: "Once you sign up, you get access instantly." },
        { icon: "flaticon-24-hours", title: "Support 24/7", description: "Get a 24 hours 7 days a week Technical Support." },
        { icon: "flaticon-privacy-policy", title: "Privacy & Security", description: "With one-time payments and 256-Bit encryption, your data is safe." },
        { icon: "flaticon-smart-tv", title: "DIY Installations", description: "No need to be 'Tech Savvy'. Just download the app on your TV." },
        { icon: "flaticon-best-price", title: "Best Pricing Plans", description: "You will not find a second place to save money with such Quality." },
      ],
    });
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const benefitsImg = require("@/assets/images/benefits.png");
    return { c, benefitsImg };
  },
});
</script>
